import React, { useRef } from 'react'; // Added useRef
import { motion } from 'framer-motion';
import './SolarProjectDetail.css';
import sideImage from '../../assets/Carrier/Contact.png';
import CustomButton from '../Button/CustomButton';

const SolarProjectDetail = () => {
    // 1. Create a reference for the form section
    const formRef = useRef(null);

    // 2. Function to handle smooth scrolling to the form
    const scrollToForm = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    return (
        <div className="job-detail-page">
            {/* HEADER: Centered as per design */}
            <header className="job-header-centered">
                <div className="container">
                    <motion.span className="job-badge" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>JOIN US</motion.span>
                    <motion.h1 initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>Solar Project Engineer</motion.h1>
                </div>
            </header>

            {/* SECTION 1: Details & Card */}
            <section className="job-info-section">
                <div className="container">
                    <div className="job-grid-layout">
                        {/* Left: Text Content */}
                        <motion.div className="job-info-left" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                            <div className="info-block">
                                <h3>About The Role</h3>
                                <p>We are looking for a motivated Solar Project Engineer – Renewable Energy to support solar, hybrid, and emerging energy projects. You will work closely with our advisory, engineering, and execution teams to help deliver projects from planning to commissioning.</p>
                            </div>

                            <div className="info-block">
                                <h3>Key Responsibilities</h3>
                                <ul>
                                    <li>Support solar and hybrid renewable energy projects.</li>
                                    <li>Assist in project planning, technical reviews, and documentation.</li>
                                    <li>Coordinate with internal teams, EPCs, and consultants.</li>
                                    <li>Help track project progress during execution.</li>
                                    <li>Support site visits, reports, and client presentations</li>
                                    <li>Follow project timelines and quality standards</li>
                                </ul>
                            </div>

                            <div className="info-block">
                                <h3>Required Qualifications</h3>
                                <ul>
                                    <li>Degree or diploma in Electrical, Mechanical, Civil, or Energy Engineering.</li>
                                    <li>0–3 years of experience in renewable energy or infrastructure.</li>
                                    <li>Basic understanding of solar power projects (preferred).</li>
                                    <li>Willingness to learn and work on-site when required</li>
                                    <li>Good communication and coordination skills</li>
                                </ul>
                            </div>
                            {/* 3. Attached scroll function to the left button */}
                            <div className="mt-4">
                                <CustomButton 
                                    variant="green" 
                                    size="md" 
                                    text="Apply now" 
                                    onClick={scrollToForm} 
                                />
                            </div>
                        </motion.div>

                        {/* Right: Summary Card */}
                        <motion.div className="job-card-right" initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
                            <div className="job-summary-card">
                                <div className="summary-row">
                                    <span className="s-label">Job Type</span>
                                    <span className="s-value">Full Time</span>
                                </div>
                                <div className="summary-row">
                                    <span className="s-label">Experience</span>
                                    <span className="s-value">0–3 Years</span>
                                </div>
                                <div className="summary-row">
                                    <span className="s-label">Location</span>
                                    <span className="s-value">Gurugram / Pune / Project Sites</span>
                                </div>
                                <div className="summary-row">
                                    <span className="s-label">Industry</span>
                                    <span className="s-value">Renewable Energy</span>
                                </div>
                                <div className="summary-row">
                                    <span className="s-label">Working Hours</span>
                                    <span className="s-value">Office hours + site coordination</span>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* SECTION 2: Form & Image - ATTACHED REF HERE */}
            <section className="job-form-section" ref={formRef}>
                <div className="container">
                    <div className="form-grid-layout">
                        {/* Left: Form Container */}
                        <motion.div className="form-box-left" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                            <h2>Apply For This Role</h2>
                            <p>Submit your details and our team will contact you if your profile matches the role.</p>

                            <form className="role-apply-form">
                                <div className="form-row">
                                    <div className="input-grp">
                                        <label>First Name</label>
                                        <div className="input-with-icon">
                                            <i className="bi bi-person"></i>
                                            <input type="text" placeholder="Enter first name" />
                                        </div>
                                    </div>
                                    <div className="input-grp">
                                        <label>Email Address</label>
                                        <div className="input-with-icon">
                                            <i className="bi bi-envelope"></i>
                                            <input type="email" placeholder="Enter email address" />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="input-grp">
                                        <label>Phone Number</label>
                                        <div className="input-with-icon">
                                            <i className="bi bi-telephone"></i>
                                            <input type="tel" placeholder="Enter phone number" />
                                        </div>
                                    </div>
                                    <div className="input-grp">
                                        <label>Current Location</label>
                                        <div className="input-with-icon">
                                            <i className="bi bi-geo-alt"></i>
                                            <input type="text" placeholder="Enter location" />
                                        </div>
                                    </div>
                                </div>

                                <div className="input-grp full-w">
                                    <label>Resume / CV</label>
                                    <div className="file-box-wrapper">
                                        <i className="bi bi-upload"></i>
                                        <input type="file" className="hidden-file-input" />
                                        <span className="file-placeholder">Upload your Resume / CV</span>
                                    </div>
                                </div>

                                <div className="input-grp full-w">
                                    <label>Short Message</label>
                                    <div className="input-with-icon align-top">
                                        <i className="bi bi-chat-dots"></i>
                                        <textarea rows="4" placeholder="Enter your message"></textarea>
                                    </div>
                                </div>

                                <button type="submit" className="submit-app-btn">Submit Application</button>
                            </form>
                        </motion.div>

                        {/* Right: Balanced Side Image */}
                        <motion.div className="form-img-right" initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}>
                            <img src={sideImage} alt="Site work" className="side-img-matched" />
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* SECTION 3: Contact Cards (Vertical Layout) */}
            <section className="job-footer-cards">
                <div className="container">
                    <div className="contact-cards-grid">
                        <div className="c-vertical-card">
                            <div className="c-icon-circle"><i className="bi bi-geo-alt"></i></div>
                            <strong>Address</strong>
                            <p>DLF Corporate Greens, Sector 74-1, <br /> Gurugram - 122004, Haryana, India</p>
                        </div>

                        <div className="c-vertical-card">
                            <div className="c-icon-circle"><i className="bi bi-envelope"></i></div>
                            <strong>Email</strong>
                            <p>info@dazbog.in</p>
                        </div>

                        <div className="c-vertical-card">
                            <div className="c-icon-circle"><i className="bi bi-telephone"></i></div>
                            <strong>Call Us</strong>
                            <p>+91 8800954675</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SolarProjectDetail;